module.exports = __webpack_public_path__ + "static/img/S.8cfaeb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S.png
// module id = wEe0
// module chunks = 1